// extracted by mini-css-extract-plugin
export default {"botoneraDecadas":"ColumnaTorneosDivision_botoneraDecadas__AQ8+N"};